import { render } from "./OrthoExportModels.vue?vue&type=template&id=f0d9bf90"
import script from "./OrthoExportModels.vue?vue&type=script&lang=js"
export * from "./OrthoExportModels.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__